import { Action } from "@/models/flows";

interface Props {
  action: Action;
  category: string;
}

export const ActionHeader = ({ action, category }: Props) => {
  return (
    <div className="flex">
      <div className={`p-1.5 bg-${action.colour}-400 rounded-lg inline-flex`}>
        <action.icon className="w-5 h-5 text-white" />
      </div>
      <div className="ml-2 flex items-center">
        <div>
          <h3 className={`uppercase text-[0.5rem] text-${action?.colour}-400`}>
            {category}
          </h3>
          <h1 className="text-[0.8rem] text-white/80 leading-tight">
            {action?.label}
          </h1>
        </div>
      </div>
    </div>
  );
};
